import React, { useState, useRef, useEffect } from "react";

// Styles //
import "./modulate-table.scss";
import {  } from "../../organisms/form-fosfec/querys/maestrasFosfec";

interface TableSelectProps {
    content: any;
    rows: number;
    setRows: React.Dispatch<React.SetStateAction<number>>;
    register: any;
    errors: any;
    setValue: any;
    getValues: any;
}

type TDataTable = {
    key: number;
    name: string;
    id: number;
};

const ModulateTable = (props: TableSelectProps) => {
    const { content, rows, setRows, register, setValue  } = props;
    const [data, setData] = useState<any[]>([]);
    const [compensationFundOptions, setCompensationFundOptions] = useState<any>([]);

    const inputFilter = (name: string) => {
        const r = content.filter((r: any) => r.name === name)[0].compensationFundOptions;
        return r;
    };

    useEffect(() => {
        setCompensationFundOptions(inputFilter("hasBeenMembershipedFoundCompensation"));
    }, []);

    useEffect(() => {
        let tempVacanies: TDataTable[] = [];
        if (rows !== 0) {
            for (let index = 1; index <= rows; index++) {
                tempVacanies.push({ key: index, name: "", id: index });
            }
        }
        setData(tempVacanies);
    }, [rows]);

    return (
        <>
            <div className="modulate-table">
                <label className="modulate-table-label">
                    Cajas de compensación en los últimos 3 años
                </label>
                <label
                    className="modulate-table-label__magenta"
                    onClick={() => {
                        if (rows < 2) {
                            setRows(rows + 1);
                        }
                    }}
                >
                    <div>+</div>
                    Agregar caja de compensación
                </label>
            </div>
            <>
                {rows !== 0 &&
                    data.map((r: any, index: number) => (
                        <>
                            <div className="modulate-table__div__inline">
                                <label
                                    className="modulate-table__div__inline__label_pointer"
                                    onClick={() => {
                                        if (rows > 1) {
                                            setRows(rows - 1);
                                            setValue("otherCompensationFund1","")
                                            setValue("afiliatedMonths1","")
                                        }
                                    }}
                                >
                                    x
                                </label>
                            </div>
                            <div className="modulate-table">
                                <div className="modulate-table__div">
                                    <label className="modulate-table-label">
                                    Caja de compensación
                                            <span>*</span>
                                        
                                    </label>
                                    <select {...register(`otherCompensationFund${index}`, { required:true})} className="a-input__select a-input__form-select">
                                        <>
                                            {(
                                            compensationFundOptions || []
                                            ).map((option, index) => {
                                                return (
                                                    <option
                                                        className="a-input__form a-input__form-select"
                                                        key={index}
                                                        value={option.value}
                                                    >
                                                        {option.label}
                                                    </option>
                                                );
                                            })}
                                        </>
                                    </select>
                                    {props.errors[`otherCompensationFund${index}`]?.type === "required" &&(
                                    <small style={{ color: "red" }}>Campo requerido</small>
                                    )}
                                </div>
                                <div className="modulate-table__div">
                                    <label className="modulate-table-label">
                                    ¿Por cuántos meses estuviste afiliado?
                                            <span>*</span>
                                        
                                    </label>
                                <input type="number"
                                    onWheel={(e) => e.currentTarget.blur()}
                                    {...register(`afiliatedMonths${index}`, { required:true , pattern : {
                                    value: /^(?!-)[0-9]+$/,
                                    message: "El número no es válido",
                                    }})} className="a-input" />
                                    {props.errors[`afiliatedMonths${index}`]?.message && (
                                    <small style={{ color: "red" }}>{props.errors[`afiliatedMonths${index}`]?.message}</small>
                                    )}
                                    {props.errors[`afiliatedMonths${index}`]?.type === "required" &&(
                                    <small style={{ color: "red" }}>Campo requerido</small>
                                    )}
                                </div>
                            </div>
                        </>
                    ))}
            </>
        </>
    );
};

export default ModulateTable;
